export const GET_PIPE_TYPE = 'GET_PIPE_TYPE';
export const PIPE_TYPE_REQUEST = 'PIPE_TYPE_REQUEST';
export const CREATE_PIPE_TYPE = 'CREATE_PIPE_TYPE';
export const UPDATE_PIPE_TYPE = 'UPDATE_PIPE_TYPE';
export const DELETE_PIPE_TYPE = 'DELETE_PIPE_TYPE';
export const PIPE_TYPE_REQUEST_FAILURE = 'PIPE_TYPE_REQUEST_FAILURE';
export const GET_PIPE_TYPE_PAGE = 'GET_PIPE_TYPE_PAGE';
export const PIPE_TYPE_REQUEST_SUCCESS = 'PIPE_TYPE_REQUEST_SUCCESS';